export default __webpack_public_path__ + "static/media/classic.e45a50a1.webp";